import { dayjs } from 'utils/providers/Timezone';
import { Event, Meta } from 'utils/types';

interface EventParams {
  data: Event;
  index: number;
}

const event = ({ data: { startAt, endAt, ...rest } }: EventParams) => ({
  data: {
    ...rest,
    startAt: dayjs(startAt).toDate(),
    endAt: dayjs(endAt).toDate(),
  },
});

interface EventWithIndex extends Event {
  index: string;
}

interface EventsParams {
  data: EventWithIndex[];
  meta: Meta;
}

const events = ({ data, meta }: EventsParams) => ({
  meta,
  data: data.map((dat, index) => event({ data: dat, index })?.data),
});

export default { event, events };
